import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Flex,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { useMemo, useState, useEffect } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import { AddIcon } from "@chakra-ui/icons";

// Custom components
import CountUpComponent from "common/components/countUpComponent";
import Pagination from "common/components/pagination/Pagination";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import EventView from "common/components/eventView";
import AddTask from "../../../../common/components/addTask";
import DataNotFound from "common/components/notFoundData";
import DateFormatter from "common/utils/dateFormater";
import { HasAccess } from "../../../../common/utils/accessUtils";
import { constant } from "common/constant";
import 'common/assets/css/viewEdit.css'
import { globalStyles } from "common/theme/styles";
import useGlobalTable from "services/Crm/utils/tableInstance";

export default function ColumnsTable(props) {
  const {
    columnsData,
    tableData,
    title,
    fetchData,
    action,
    setAction,
    access,
    allData,
    initialValues,
    lead,
    dynamic=false
  } = props;
  const buttonbg = useColorModeValue("gray.200", "white");
  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const navigate = useNavigate();

  const [id, setId] = useState();
  const [eventView, setEventView] = useState(false);
  const [permission, leadAccess, contactAccess] = HasAccess([
    "Tasks",
    "Leads",
    "Contacts",
  ]);
  const [taskModel, setTaskModel] = useState(false);
  const [gopageValue, setGopageValue] = useState();


  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex, pageSize,
  } = useGlobalTable(columns, data);

  if (pageOptions.length < gopageValue) {
    setGopageValue(pageOptions.length);
  }

  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const param = useParams();
  const location = useLocation();
  const leadContect = location.pathname.includes(constant.viewLabels.lead)
    ? constant.viewLabels.lead
    : constant.viewLabels.contact;

  const handleDateClick = (cell) => {
    setId(cell?.original?._id);
    setEventView(true);
  };

  useEffect(() => {
    if (gopageValue === undefined && pageOptions.length < gopageValue) {
      setGopageValue(pageOptions.length);
    }
  }, [pageOptions, gopageValue]);

     useEffect(() => {
    document.body.classList.add("bgWhiteImp");
    return () => {
      document.body.classList.remove("bgWhiteImp");
    };
  }, []);

  return (
    <>
      <Box className="viewEditAccordian">
        <Box className="viewEditAccordianItem">
          <Box className="viewEditAccordianBtn">
            <Flex justify="space-between" flex="1" align="center">
              <Flex gap={"20px"} alignItems={"center"}>
                <Heading className="viewEditAccordianHeader" size="md">
                  {title}
                  {/* (
                  <CountUpComponent key={allData?.task?.length} targetNumber={allData?.task?.length} />
                  ) */}
                </Heading>
                {/* <AccordionIcon color={globalStyles.colors.iconDark} /> */}
              </Flex>

              <Button
                // onClick={(event) => {
                //   event.stopPropagation();
                //   setTaskModel(true);
                // }}
                onClick={() => navigate("/crm/tasks/createTask", {
                  state: {
                    initialValuesProp: initialValues,
                    view: lead ? constant.lead : dynamic ? initialValues?.dealName ? constant.deals : constant.accounts : constant.contact,

                  },
                })}
                leftIcon={<AddIcon fontSize={"12px"} color={globalStyles.colors.iconDark} />}
                className="accordianAddBtn"
              >
                {constant.addNew}
              </Button>



            </Flex>
          </Box>
          <Box className="viewEditAccordianPannel" pb={4}>

            <Box overflowY={"auto"} className="table-container p0">
              <Table {...getTableProps()} variant="simple" color="gray.500" mb="24px" className="lead-table-main">
                <Thead className="viewEditAccordian-tableHead">
                  {headerGroups?.map((headerGroup, index) => (
                    <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                      {headerGroup.headers.map((column, index) => (
                        <Th {...column.getHeaderProps(column.getSortByToggleProps())} key={index} borderColor={borderColor}>
                          <Flex justifyContent={column.center ? "center" : "start"} align="center">
                            <span style={{ textTransform: "capitalize", marginRight: "8px" }}>{column.render("Header")}</span>
                          </Flex>
                        </Th>
                      ))}
                    </Tr>
                  ))}
                </Thead>
                <Tbody {...getTableBodyProps()}>
                  {data?.length === 0 ? (
                    <Tr>
                      <Td colSpan={columns?.length} textAlign="center" className="nodataTd">
                        <DataNotFound title={"Tasks"} />
                      </Td>
                    </Tr>
                  ) : (
                    page?.map((row, index) => {
                      prepareRow(row);
                      const rowLink = `/crm/tasks/taskView/${row.original._id}`;
                      return (
                        <Tr onClick={() => navigate(rowLink)} {...row?.getRowProps()} key={index}>
                          {row?.cells?.map((cell, index) => {
                            let data = "";
                            if (cell?.column.Header === "Title") {
                              data = (
                                <Text
                                  color="brand.600"
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {cell?.value}
                                </Text>
                              );
                            } else if (cell?.column.Header === "Category") {
                              data = (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {cell?.value}
                                </Text>
                              );
                            } else if (cell?.column.Header === "Assign To") {
                              data = (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {cell?.value ? cell?.value : " - "}
                                </Text>
                              );
                            } else if (cell?.column.Header === "Start Date") {
                              data = (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {DateFormatter(cell?.value)}
                                </Text>
                              );
                            } else if (cell?.column.Header === "End Date") {
                              data = (
                                <Text
                                  color={textColor}
                                  fontSize="sm"
                                  fontWeight="700"
                                >
                                  {DateFormatter(cell?.value)}
                                </Text>
                              );
                            }
                            return (
                              <Td
                                {...cell?.getCellProps()}
                                key={index}
                                cursor="pointer"
                                fontSize={{ sm: "14px" }}
                                minW={{ sm: "150px", md: "200px", lg: "auto" }}
                                borderColor="transparent"
                                onClick={() => handleDateClick(row)}
                              >
                                {data}
                              </Td>
                            );
                          })}
                        </Tr>
                      );
                    })
                  )}
                </Tbody>
              </Table>
            </Box>
            {data?.length > 5 && (
              <Pagination
                gotoPage={gotoPage}
                gopageValue={gopageValue}
                setGopageValue={setGopageValue}
                pageCount={pageCount}
                canPreviousPage={canPreviousPage}
                previousPage={previousPage}
                canNextPage={canNextPage}
                pageOptions={pageOptions}
                setPageSize={setPageSize}
                nextPage={nextPage}
                pageSize={pageSize}
                pageIndex={pageIndex}
              />
            )}
          </Box>
        </Box>
      </Box>

      {taskModel && (
        <AddTask
          fetchData={fetchData}
          isOpen={taskModel}
          leadContect={leadContect}
          onClose={setTaskModel}
          setAction={setAction}
          from="lead"
          id={param.id}
        />
      )}
    </>
  );
}
